import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostsService } from '../posts.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import * as PrismicDOM from 'prismic-dom';
import * as _ from 'lodash';


function youtubeParser(url){
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  var match = url.match(regExp);
  return (match&&match[7].length==11)? match[7] : false;
}


@Component({
  selector: 'app-history-post',
  templateUrl: './history-post.component.html',
  styleUrls: ['./history-post.component.css']
})
export class HistoryPostComponent implements OnInit {

  public post;
  public loading: boolean;

  getPost(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.posts.getHistory(id).then((post) => {
      console.log("getHistory: ", post);
      // let post = _.first(posts);
      post.data.content_blocks = _.map(post.data.content_blocks, (block) => {
        if (block.video && block.video.url) {
          let url = block.video.url;
          if (url.indexOf('youtu') > -1 && url.indexOf('/embed') < 0) {
            let id = youtubeParser(url);
            url = 'https://www.youtube.com/embed/' + id
          }
          block.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          return block;
        } else return block;
      });
      this.post = post;
      this.loading = false;
      // this.titleService.setTitle(product.title + " -- Bender Hardware Shop");
    });
  }

  generateMarkup(data) {
    return PrismicDOM.RichText.asHtml(data);
  }

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer, private posts: PostsService, private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle("History -- Bender Hardware");
    this.loading = true;
    this.getPost();

  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/history-post/history-post.component.ts